import { IconVariant } from "@/components/atoms";
import { QuickSetupModal } from "./QuickSetupModal";

interface WalkthroughModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
  subtitle?: string;
  videoUrl: string;
  featuredIcon?: {
    name: string;
    background?: string;
    className?: string;
    isCustom?: boolean;
    variant?: IconVariant;
  };
}

export const WalkthroughModal = ({ open, onClose, title, subtitle, videoUrl, featuredIcon }: WalkthroughModalProps) => {
  return (
    <QuickSetupModal
      open={open}
      onClose={onClose}
      title={title}
      subtitle={subtitle}
      variant="web-large"
      content={{
        type: "video",
        videoUrl,
      }}
      className="max-h-[90vh]"
      featuredIcon={featuredIcon}
    />
  );
};
